<div class="cpp-heading" *ngIf="pageTitle">
  <div class="cpp-heading__content">
    <h1 class="cpp-heading__title">{{pageTitle}}</h1>
  </div>
</div>

<iframe
  (load)="removeLoader()"
  [src]="iframeUrl"
  width="100%"
  height="950"
  frameborder="0">
</iframe>
